import React, { CSSProperties, FC } from 'react';
import styles from './Button.module.scss';

export type ButtonProps = {
    fontSize?: string;
    height?: string;
    width?: string;
    icon?: string;
    iconSize?: string;
    title?: string;
    disabled?: boolean;
    pending?: boolean;
    style?: CSSProperties;
    onClick?: () => void;
};

const Button: FC<ButtonProps> = ({
    width = '100%',
    fontSize = '14px',
    height = '40px',
    title,
    disabled = false,
    icon,
    iconSize = '16px',
    style = {},
    pending = false,
    onClick,
}) => {
    return (
        <button
            onClick={() => !disabled && onClick && onClick()}
            className={`${styles.Button} ${disabled || pending ? styles.disabled : ''}`}
            style={{ fontSize, height, width, ...style }}>
            {icon && (
                <img
                    src={icon}
                    style={{ width: iconSize, height: iconSize, opacity: disabled ? 0.5 : 1 }}
                />
            )}
            {title && !pending && title}
            {pending && <div className="spinner small"></div>}
        </button>
    );
};

export default Button;
